import { CobrowsingInfo } from '@agent/core/store/cobrowsing/cobrowsing.model';
import { Injectable } from '@angular/core';

import * as CobrowsingAction from './cobrowsing.action';

export { CobrowsingAction };

@Injectable({
  providedIn: 'root',
})
export class CobrowsingDispatcher {
  public initCobrowsing(info: CobrowsingInfo) {
    return CobrowsingAction.InitCobrowsing({ info });
  }

  public startCobrowsing(info: CobrowsingInfo) {
    return CobrowsingAction.StartCobrowsing({ info });
  }

  public startCobrowsingError(info: CobrowsingInfo) {
    return CobrowsingAction.StartCobrowsingError({ info });
  }

  public cobrowsingStarted(info: CobrowsingInfo) {
    return CobrowsingAction.CobrowsingStarted({ info });
  }

  public endCobrowsing(bookingId: string) {
    return CobrowsingAction.EndCobrowsing({ bookingId });
  }

  public cobrowsingEnded(bookingId: string) {
    return CobrowsingAction.CobrowsingEnded({ bookingId });
  }

  public cobrowsingSessionUpdated(info: CobrowsingInfo) {
    return CobrowsingAction.CobrowsingSessionUpdated({ info });
  }

  public removeCobrowsing(bookingId: string) {
    return CobrowsingAction.RemoveCobrowsing({ bookingId });
  }
}
